import api from './api';

export interface ChatMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export interface ChatContext {
  orderId?: string;
  language?: 'en' | 'tw';
}

export interface ChatResponse {
  success: boolean;
  content: string;
  model?: string;
  usage?: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
  fallback?: boolean;
}

export const chatAPI = {
  /**
   * Send messages to chat API
   */
  async sendMessage(
    messages: ChatMessage[],
    context: ChatContext = {}
  ): Promise<ChatResponse> {
    const response = await api.post('/chat', { messages, context });
    return response.data;
  },

  /**
   * Check chat service health
   */
  async checkHealth(): Promise<{ success: boolean; configured: boolean; model: string }> {
    const response = await api.get('/chat/health');
    return response.data;
  }
};

export default chatAPI;